import { Injectable } from '@angular/core';
import { InstantMeetingSettings } from './interfaces/service-interfaces';
import { MeetingSource, GoogleMeetMeetingAttendeeInterface } from '@vendasta/meetings';
import { BaseMeetingService } from './base-meeting.service';
import { MeetingIntegrationsServiceModule } from '../meeting-integrations-service.module';

@Injectable({ providedIn: MeetingIntegrationsServiceModule })
export class MicrosoftMeetService extends BaseMeetingService {
  protected getAttendeesFromSettings(_: InstantMeetingSettings): GoogleMeetMeetingAttendeeInterface[] {
    return [];
  }

  protected getMeetingSource(): MeetingSource {
    return MeetingSource.MEETING_SOURCE_MICROSOFT;
  }
}
